"use strict";
/**
 * Simplified Configuration
 * No versioning - always use root-relative paths
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.debugConfig = exports.appConfig = void 0;
var runtimeConfig = {
    basePath: '/',
    isDev: false
};
var configFactory = function () {
    // Get build-time configuration (with fallbacks for development)
    var buildVersion = typeof AUDROAM_VERSION !== 'undefined' && AUDROAM_VERSION ? AUDROAM_VERSION : '1.5.86';
    var lastVersion = typeof AUDROAM_LAST_VERSION !== 'undefined' && AUDROAM_LAST_VERSION ? AUDROAM_LAST_VERSION : '1.5.85';
    var buildMode = typeof AUDROAM_BUILD_MODE !== 'undefined' && AUDROAM_BUILD_MODE ? AUDROAM_BUILD_MODE : 'development';
    return {
        ver: "v".concat(buildVersion),
        buildMode: buildMode,
        runtimeConfig: runtimeConfig,
        // Fixed root configuration
        baseURI: (typeof window !== 'undefined' ? window.location.host : 'localhost:8080'),
        basePath: runtimeConfig.basePath,
        api1: (typeof window !== 'undefined'
            ? "".concat(window.location.origin, "/api/api.php")
            : "http://localhost:8080/api/api.php"),
        // Unified API - root-relative path
        apiBaseURI: (typeof window !== 'undefined' ? window.location.host : 'localhost:8080'),
        apiBasePath: '/api/',
        api: (typeof window !== 'undefined'
            ? "".concat(window.location.origin, "/api/api.php")
            : "http://localhost:8080/api/api.php"),
    };
};
// Export dynamic configuration
exports.appConfig = configFactory();
// Export utilities for debugging
exports.debugConfig = {
    buildVersion: typeof AUDROAM_VERSION !== 'undefined' ? AUDROAM_VERSION : 'undefined',
    lastVersion: typeof AUDROAM_LAST_VERSION !== 'undefined' ? AUDROAM_LAST_VERSION : 'undefined',
    buildMode: typeof AUDROAM_BUILD_MODE !== 'undefined' ? AUDROAM_BUILD_MODE : 'undefined',
    runtimeDetected: exports.appConfig.runtimeConfig,
};
